var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 314 314",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,138.428c-3.866,0-7,3.134-7,7v23.145c0,3.866,3.134,7,7,7s7-3.134,7-7v-23.145C14,141.561,10.866,138.428,7,138.428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.273,138.428c-3.866,0-7,3.134-7,7v23.145c0,3.866,3.134,7,7,7s7-3.134,7-7v-23.145 C41.273,141.561,38.14,138.428,34.273,138.428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.546,128.635c-3.866,0-7,3.134-7,7v42.73c0,3.866,3.134,7,7,7s7-3.134,7-7v-42.73 C68.546,131.769,65.412,128.635,61.546,128.635z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.818,117.063c-3.866,0-7,3.134-7,7v65.875c0,3.866,3.134,7,7,7c3.866,0,7-3.134,7-7v-65.875 C95.818,120.196,92.685,117.063,88.818,117.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.092,96.588c-3.866,0-7,3.134-7,7v106.824c0,3.866,3.134,7,7,7c3.866,0,7-3.134,7-7V103.588 C123.092,99.722,119.958,96.588,116.092,96.588z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.364,48.071c-3.866,0-7,3.134-7,7v203.857c0,3.866,3.134,7,7,7c3.866,0,7-3.134,7-7V55.071 C150.364,51.205,147.23,48.071,143.364,48.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.637,65.43c-3.866,0-7,3.134-7,7V241.57c0,3.866,3.134,7,7,7c3.866,0,7-3.134,7-7V72.43 C177.637,68.563,174.503,65.43,170.637,65.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.909,100.148c-3.866,0-7,3.134-7,7v99.703c0,3.866,3.134,7,7,7c3.866,0,7-3.134,7-7v-99.703 C204.909,103.282,201.775,100.148,197.909,100.148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.183,121.067c-3.866,0-7,3.134-7,7v57.864c0,3.866,3.134,7,7,7s7-3.134,7-7v-57.864 C232.183,124.201,229.049,121.067,225.183,121.067z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.456,129.971c-3.866,0-7,3.134-7,7v40.059c0,3.866,3.134,7,7,7c3.866,0,7-3.134,7-7v-40.059 C259.456,133.105,256.322,129.971,252.456,129.971z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.728,138.428c-3.866,0-7,3.134-7,7v23.145c0,3.866,3.134,7,7,7c3.866,0,7-3.134,7-7v-23.145 C286.728,141.561,283.594,138.428,279.728,138.428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,138.428c-3.866,0-7,3.134-7,7v23.145c0,3.866,3.134,7,7,7s7-3.134,7-7v-23.145 C314,141.561,310.866,138.428,307,138.428z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.b92524b2cfc2e8ebf3fd9b1ef688f550.svg";
export { ForwardRef as ReactComponent };